import type { FunctionComponent } from "react";

import { contacts } from "./data";
import { Contact, Container, Telephone, Title } from "./styles";

type Props = {
  className?: string;
};

export const PostiesEnquires: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <Title>For any enquiries: </Title>
    {contacts.map((contact, index) => (
      <Contact key={index}>
        <span>{contact.name}</span>
        {contact.email}
      </Contact>
    ))}
    <Telephone>
      Tel: <span>(852) 2680 8822</span>
    </Telephone>
  </Container>
);

PostiesEnquires.displayName = "PostiesEnquires";
